import { StandardEvents } from '@shopify/events';

/**
 * Keeps the NestBuddy header's cart badge in sync with the cart without a
 * page refresh. The header itself is static Liquid/CSS by design, so this
 * just listens for the same cart update event the rest of the theme's add
 * to cart / stepper components already dispatch.
 */
function updateCartCount(itemCount) {
  document.querySelectorAll('[data-nb-cart-count]').forEach((el) => {
    el.textContent = String(itemCount);
    el.hidden = itemCount === 0;
  });

  document.querySelectorAll('[data-nb-cart-link]').forEach((link) => {
    link.setAttribute('aria-label', `Cart, ${itemCount} items`);
  });
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart, detail }) => {
      const itemCount = cart?.totalQuantity ?? detail?.itemCount ?? 0;
      updateCartCount(itemCount);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[nb-cart-count] Event promise rejected:', error);
    });
});
